import { useLayoutEffect } from "react";
import { scrollBarWidth } from "../../../../common/html-width-helpers";
import { language } from "../../../../language/default";
import { setCurrentStatusMasterDetails } from "../../../../store/current-dashboard";
import { defaultMargin, defaultRightMargin, minimumBarWidth } from "./constants";
import { getDataLabelDisplayValue, labelFormatter } from "./ins-horizontal-bar-chart-formatter";
import { CommmonFormatEnum } from "datapoints";
import { ChartSelectValueFormatKind, DisplayValueType } from "store/current-dashboard/types";
const calculateMaxWidth = (values, chart, margin) => {
    let width = 0;
    const canvas = document.createElement("canvas"), context = canvas.getContext("2d");
    if (context && chart.current && chart.current.container.current) {
        context.font = window.getComputedStyle(chart.current.container.current).font;
        for (const text of values) {
            width = Math.max(context.measureText(text).width, width);
        }
    }
    return width + margin + 10;
};
export const defineLabelsWidth = ({ chartRef, options, categories, chartContainerRef, masterDetailChoiceIndex, childrenId, hasRightAlignedLabels, dataLabelExtraMargin = 0 }) => {
    if (chartRef?.current && chartContainerRef.current && options.chart) {
        const { chart } = chartRef.current, margin = chart.chartWidth - chart.plotWidth - (options.chart.marginLeft || defaultMargin);
        // Average difference in size between chart width and plot width when plot size is final (accounting for margins, axis, legends ....)
        const averageDifferenceInSize = 100, 
        // A bar occupies approximetly 3 times its size when accouunting for margins
        multiplierForSpacing = 3;
        const categoriesMaxLength = calculateMaxWidth(categories, chartRef, margin), computedOffsetRightForLargestLabels = hasRightAlignedLabels ? dataLabelExtraMargin - margin : 0, marginLeft = Math.min(chartContainerRef.current.offsetWidth / 2, categoriesMaxLength) + computedOffsetRightForLargestLabels, marginRight = defaultRightMargin + dataLabelExtraMargin, maxRows = Math.min(Math.round((chartContainerRef.current.offsetHeight - averageDifferenceInSize) / (minimumBarWidth * multiplierForSpacing)), categories.length - 1);
        const newOptions = {
            chart: {
                ...options.chart,
                marginLeft,
                marginRight: categories.length - 1 > maxRows ? scrollBarWidth + marginRight : marginRight
            },
            xAxis: {
                ...options.xAxis,
                labels: {
                    formatter() {
                        return labelFormatter(this, {
                            childrenId,
                            masterDetailChoiceIndex: masterDetailChoiceIndex || 0,
                            width: marginLeft
                        });
                    }
                },
                max: maxRows,
                offset: computedOffsetRightForLargestLabels,
                scrollbar: {
                    enabled: categories.length - 1 > maxRows,
                    margin: dataLabelExtraMargin + scrollBarWidth
                }
            }
        };
        chart.update(newOptions, true, false, false);
    }
};
export const onRenderHorizontalBarChart = (context, widgetProps, dispatch, sectionId, widgetId) => {
    const [axis] = context.xAxis;
    const { ticks } = axis;
    if (context.series?.length > 0 && widgetProps.childrenId) {
        const [{ points }] = context.series;
        points.forEach((point, i) => {
            if (ticks[i]) {
                const label = ticks[i].label?.element;
                if (label) {
                    label.onclick = () => {
                        dispatch(setCurrentStatusMasterDetails({
                            childrenId: widgetProps?.childrenId,
                            sectionId,
                            selectedValue: point.options?.custom?.id ?? point.name,
                            widgetId
                        }));
                    };
                }
            }
        });
    }
};
export const getScaleLegendText = (displayKind, displayValueType) => {
    if (displayKind) {
        switch (displayKind) {
            case ChartSelectValueFormatKind.percent:
                return "%";
            case ChartSelectValueFormatKind.multiple:
                return language.en.widget.multiples;
            default:
                return "";
        }
    }
    return !displayValueType || displayValueType === DisplayValueType.Percent
        ? "%"
        : "";
};
export const getScaleLegendText2 = (format) => {
    switch (format) {
        case CommmonFormatEnum.percent:
            return "%";
        case CommmonFormatEnum.multiple:
            return language.en.widget.multiples;
        default:
            return "";
    }
};
export const useCalculateDesign = (params) => {
    const { chartRef, chartContainerRef, dataLabelsEnabled, data, options, valueFormat, displayValueType, noDefineLabel, categories, childrenId, preformatted, masterDetailChoiceIndex } = params;
    useLayoutEffect(() => {
        if (chartRef?.current) {
            chartRef?.current.chart.xAxis[0].setExtremes();
            chartRef?.current.chart.yAxis[0].setExtremes();
            const dataLabelExtraMargin = dataLabelsEnabled
                ? calculateMaxWidth(preformatted
                    ? data.map((d) => d?.value)
                    : data.map((x) => getDataLabelDisplayValue(x, valueFormat, displayValueType)), chartRef, 0)
                : 0;
            if (noDefineLabel === false) {
                defineLabelsWidth({
                    categories: categories ?? data?.map((d) => d.name),
                    chartContainerRef,
                    chartRef,
                    childrenId,
                    dataLabelExtraMargin,
                    hasRightAlignedLabels: dataLabelsEnabled,
                    masterDetailChoiceIndex: masterDetailChoiceIndex ?? 0,
                    options
                });
            }
        }
    }, [valueFormat, dataLabelsEnabled, preformatted, options, displayValueType, data, chartRef, chartContainerRef, noDefineLabel, categories, childrenId, masterDetailChoiceIndex]);
};
